import { render, staticRenderFns } from "./AuthSecurity.vue?vue&type=template&id=a4a7e90c&scoped=true&"
import script from "./AuthSecurity.vue?vue&type=script&lang=js&"
export * from "./AuthSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7e90c",
  null
  
)

export default component.exports